import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// utils

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        width: '100%'
    }
});



class FormFieldDataScadenza extends Component {

    render() {
        const { classes, data_decorrenza, handleChangeField, errorText } = this.props;

        return (
            <div className={classes.alignLeft}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        /*minDate={subDays(startOfToday(), 1)}*/
                        margin="normal"
                        value={data_decorrenza}
                        onChange={date => handleChangeField(date)}
                        KeyboardButtonProps={{ 'aria-label': 'change date' }}
                        error={errorText.data_decorrenza !== '' ? true : false}
                        helperText={errorText.data_decorrenza !== '' ? errorText.data_decorrenza : null}
                    />
                </MuiPickersUtilsProvider>
            </div>
        );
    }
}

FormFieldDataScadenza.propTypes = {
    handleChangeField: PropTypes.func.isRequired,
    data_decorrenza: PropTypes.instanceOf(Date),

    errorText: PropTypes.shape({}).isRequired,
};

export default withStyles(styles)(FormFieldDataScadenza);